/**
 * @generated SignedSource<<442da72c3bc1ecd2370ff5cf5a881f1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddExcludeUserDispatchConditionInput = {
  clientMutationId?: string | null;
  messageDispatchId: string;
  userIds: ReadonlyArray<string>;
};
export type useDispatchConditions_AddExcludeUserDispatchConditionMutation$variables = {
  input: AddExcludeUserDispatchConditionInput;
};
export type useDispatchConditions_AddExcludeUserDispatchConditionMutation$data = {
  readonly Admin: {
    readonly Message: {
      readonly addExcludeUserDispatchCondition: {
        readonly clientMutationId: string | null;
      } | null;
    };
  };
};
export type useDispatchConditions_AddExcludeUserDispatchConditionMutation = {
  response: useDispatchConditions_AddExcludeUserDispatchConditionMutation$data;
  variables: useDispatchConditions_AddExcludeUserDispatchConditionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Message",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "AddExcludeUserDispatchConditionPayload",
            "kind": "LinkedField",
            "name": "addExcludeUserDispatchCondition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDispatchConditions_AddExcludeUserDispatchConditionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDispatchConditions_AddExcludeUserDispatchConditionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dc0f4b989396dbb4e5d5854620345d59",
    "id": null,
    "metadata": {},
    "name": "useDispatchConditions_AddExcludeUserDispatchConditionMutation",
    "operationKind": "mutation",
    "text": "mutation useDispatchConditions_AddExcludeUserDispatchConditionMutation(\n  $input: AddExcludeUserDispatchConditionInput!\n) {\n  Admin {\n    Message {\n      addExcludeUserDispatchCondition(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c96be1dc24b9bb850972662970bb1f9";

export default node;
